export const GRAPH_TYPE_OPTIONS = [
  {
    value: 'social',
    label: 'Social Map',
    description: 'Friends, lovers, school, coworkers, and the stories of how a group formed.',
  },
  {
    value: 'family',
    label: 'Family Tree',
    description: 'Generations, birth and death dates, children, siblings, partners, and marriages.',
  },
  {
    value: 'wedding',
    label: 'Wedding',
    description: 'Couples, families, wedding party, guests, and the connections around a celebration.',
  },
];

export function normalizeGraphType(type) {
  return GRAPH_TYPE_OPTIONS.some((option) => option.value === type) ? type : 'social';
}

export function getGraphTypeLabel(type) {
  const normalizedType = normalizeGraphType(type);
  return GRAPH_TYPE_OPTIONS.find((option) => option.value === normalizedType)?.label || GRAPH_TYPE_OPTIONS[0].label;
}
